// Unified tier pricing — single source of truth for all internal app calculations
// Prices are monthly equivalents matching Stripe price IDs in CLAUDE.md
//
// Tier structure (as of Feb 2026):
//   Pro:      1 user + 2 @ $5    — $12.50/wk, $50/mo, $500/yr
//   Team:     3 users + 2 @ $5   — $25/wk, $100/mo, $1000/yr
//   Business: 5 users + 5 @ $5   — $50/wk, $200/mo, $2000/yr
//   Growth:   10 users + 10 @ $5 — $125/wk, $500/mo, $5000/yr

export const TIER_PRICING = {
  pro: {
    weekly: 12.50,
    monthly: 50,
    annual: 500
  },
  team: {
    weekly: 25,
    monthly: 100,
    annual: 1000
  },
  business: {
    weekly: 50,
    monthly: 200,
    annual: 2000
  },
  growth: {
    weekly: 125,
    monthly: 500,
    annual: 5000
  }
};

export const SEAT_PRICE = 5; // $5/seat/month

// Weeks per month for weekly→monthly conversion
const WEEKS_PER_MONTH = 4.33;

/**
 * Get monthly revenue equivalent for a given tier + billing interval
 */
export function getMonthlyRevenue(tier, billingInterval) {
  const pricing = TIER_PRICING[tier] || TIER_PRICING.pro;
  const base = pricing[billingInterval] || pricing.monthly;

  if (billingInterval === 'weekly') return base * WEEKS_PER_MONTH;
  if (billingInterval === 'annual') return base / 12;
  return base; // monthly
}

/**
 * Get the monthly-equivalent price map (for grids/dashboards)
 * Returns { pro: { weekly: ~54.13, monthly: 50, annual: ~41.67 }, ... }
 */
export function getMonthlyEquivalents() {
  const result = {};
  for (const [tier, prices] of Object.entries(TIER_PRICING)) {
    result[tier] = {
      weekly: prices.weekly * WEEKS_PER_MONTH,
      monthly: prices.monthly,
      annual: prices.annual / 12
    };
  }
  return result;
}

/**
 * All valid tier names
 */
export const TIER_NAMES = ['pro', 'team', 'business', 'growth'];

/**
 * Display labels for tiers
 */
export const TIER_LABELS = {
  pro: 'Pro',
  team: 'Team',
  business: 'Business',
  growth: 'Growth'
};
